import Decimal from 'decimal.js';
import { ReactNode } from 'react';

import { MiniTableRow } from '@/components/tables/MiniTable/MiniTable';

export interface EntityCoverSlideDataPoint {
  label: ReactNode;
  value: ReactNode;
  subText?: string;
  Icon: React.ComponentType;
}

export interface EntityCoverSlideDetailsList {
  title: string;
  entries: MiniTableRow[];
}

export enum EntityCoverSlideDetailsListVariant {
  ThreeColumn = 3,
  TwoColumn = 2,
  OneColumn = 1,
}

export interface EntityCoverSlideData {
  title: string;
  dataPoints: EntityCoverSlideDataPoint[];
  detailsLists: EntityCoverSlideDetailsList[];
  detailsListsVariant?: EntityCoverSlideDetailsListVariant;
  totalDeathBenefit?: Decimal | undefined;
}
